var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaystation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11017_9977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.02263 34.6834C-0.871001 35.9398 -0.23979 38.3269 3.79996 39.4576C7.96595 40.8396 12.5107 41.2165 16.9291 40.4627C17.1816 40.4627 17.4341 40.3371 17.5603 40.3371V36.0654L13.2681 37.4474C11.627 37.95 9.98582 38.0756 8.34467 37.6987C7.08225 37.3218 7.33474 36.568 8.84964 35.9398L17.5603 32.9245V28.276L5.4411 32.422C3.9262 32.9245 2.41129 33.6783 1.02263 34.6834V34.6834ZM30.3108 15.8379V28.0247C35.4867 30.5374 39.5265 28.0247 39.5265 21.4916C39.5265 14.8328 37.1279 11.8176 30.1846 9.43047C26.5235 8.1741 22.7363 7.04337 18.949 6.28955V42.5985L27.786 45.2369V14.7072C27.786 13.3252 27.786 12.3201 28.7959 12.697C30.1846 13.0739 30.3108 14.4559 30.3108 15.8379V15.8379ZM46.7223 31.7938C43.0613 30.5374 39.1477 30.0349 35.3605 30.4118C33.3406 30.5374 31.447 31.04 29.6796 31.6682L29.3009 31.7938V36.6936L37.5066 33.6783C39.1477 33.1758 40.7889 33.0502 42.43 33.4271C43.6925 33.804 43.44 34.5578 41.9251 35.186L29.3009 39.8345V44.6087L46.7223 38.2013C47.9847 37.6987 49.1209 37.0705 50.1308 36.0654C51.0145 34.8091 50.6358 33.0502 46.7223 31.7938V31.7938Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11017_9977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.5263,
    height: 50.5263,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystation);
export default __webpack_public_path__ + "static/media/playstation.04a839b74741286fbbdf2459e4c21caa.svg";
export { ForwardRef as ReactComponent };